export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "pending";
    PaymentStatus["COMPLETED"] = "completed";
    PaymentStatus["FAILED"] = "failed";
    PaymentStatus["EXPIRED"] = "expired";
})(PaymentStatus || (PaymentStatus = {}));
//# sourceMappingURL=payment.model.js.map